import { BookingService } from '../Booking/Service';

// Keep the Customer bookings detailed report limited to the requested columns, in this order.
export const bookingServiceHeaders = [
  'Booking', 'Submitted (IST)', 'Flow', 'Status', 'Service date', 'Requested service', 'Booking total (INR)',
  'Customer ID', 'Customer name', 'Customer contact', 'City', 'State', 'Pincode', 'Expert ID', 'Expert name', 'Expert contact',
];
const value = (input) => input ?? 'Unavailable';

const bookingServiceValues = (booking, detail, serviceName, indiaTime, person = {}) => [
  value(booking.bookingNumber ?? booking.number ?? detail?.bookingNumber),
  indiaTime(booking.booked_at ?? booking.submitted_at), value(booking.bookingSource ?? detail?.bookingSource),
  value(booking.bookingStatus ?? booking.status ?? detail?.bookingStatus), value(detail?.serviceDate), value(serviceName),
  value(detail?.total ?? booking.total), value(detail?.customerId ?? person.customer_id), value(detail?.customerName),
  value(detail?.customer?.mobileNumber ?? person.mobile_number), value(detail?.add_city), value(detail?.add_state),
  value(detail?.add_pincode), value(detail?.providerId), value(detail?.providerName), value(detail?.provider?.mobileNumber),
];

async function loadBookingServiceDetail(id) {
  if (!Number.isSafeInteger(Number(id)) || Number(id) < 1) throw new Error('Could not load all booking service details. Please try again.');
  const response = await BookingService.bookingDetailById(id);
  if (response?.success !== 1 || !response.data || !Array.isArray(response.data.bookingItems)) {
    throw new Error('Could not load all booking service details. Please try again.');
  }
  return response.data;
}

export async function bookingServiceRows(bookings, indiaTime, isCurrent) {
  const rows = [];
  for (const booking of bookings) {
    if (!isCurrent()) return null;
    if (booking.recordType === 'quick_book_request') {
      rows.push(bookingServiceValues(booking, null, null, indiaTime));
      continue;
    }
    const detail = await loadBookingServiceDetail(booking.id);
    if (!isCurrent()) return null;
    for (const item of detail.bookingItems.length ? detail.bookingItems : [null]) {
      rows.push(bookingServiceValues(booking, detail, item?.serviceName, indiaTime));
    }
  }
  return rows;
}
